/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IObjectKey {
  [key: string]: any
}

export default function EncodeJSON(data: IObjectKey) {
  for (const key in data) {
    data[key] = EncodeData(data, key)
  }
  return data
}

export function EncodeData(data: IObjectKey, key: string) {
  const isArray = Array.isArray(data[key])
  if (isArray) {
    for (const index in data[key]) {
      for (const i in data[key][index]) {
        data[key][index][i] = EncodeData(data[key][index], i)
      }
    }
  } else {
    // Skip encoding for complex objects (like fill-blank data)
    if (typeof data[key] === 'object' && data[key] !== null) {
      // Don't encode complex objects, return as-is
      return data[key]
    }

    // Only encode strings
    if (typeof data[key] === 'string') {
      if (key === 'accessibility') {
        data[key] = ClearString(data[key])
      }
      data[key] = encodeURI(data[key])
    }
  }
  return data[key]
}

export function ClearString(string: string) {
  return string.split(`"`).join(`'`)
}
